import { render, staticRenderFns } from "./StepConfirmation.vue?vue&type=template&id=24c6a2ff&scoped=true"
import script from "./StepConfirmation.vue?vue&type=script&lang=ts"
export * from "./StepConfirmation.vue?vue&type=script&lang=ts"
import style0 from "./StepConfirmation.vue?vue&type=style&index=0&id=24c6a2ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c6a2ff",
  null
  
)

export default component.exports